export default {
  cloneFromType: {
    survey: 'Судалгаа',
    template: 'Загвар',
  },
  createSurvey: 'Судалгаа үүсгэх',
  createTemplate: 'Загвар үүсгэх',
  newSurvey: 'Шинэ судалгаа',
  newSurveyFromScratch: 'Шинэ судалгааг хоосноос эхлүүлэх',
  newTemplate: 'Шинэ загвар',
  newTemplateFromScratch: 'Шинэ загварыг хоосноос эхлүүлэх',
  source: {
    label: 'Эх сурвалж',
    arena: 'Arena (.zip)',
    collect: 'Collect (.collect, .collect-backup, .collect-data)',
    odk: 'ODK (.xml)',
  },
  startImport: 'Импорт эхлүүлэх',
  survey: 'Судалгаа',
  survey_other: 'Судалгаанууд',
  template: 'Загвар',
  template_other: 'Загварууд',
  error: 'Шинэ судалгаа үүсгэхэд алдаа гарлаа',
  errorMaxSurveysCountExceeded:
    'Судалгаа үүсгэхэд алдаа гарлаа; та үүсгэх боломжтой судалгааны хамгийн их тоо ({{maxSurveysCount}})-д хүрлээ.',
  options: {
    includeData: 'Өгөгдөл оруулах',
  },
}
